<template>
  <section class="commercial-index">
    <settings-list :items="items" />
  </section>
</template>

<script>
  import pricesIcon from '@/assets/images/illustrations/settings/commercial/prices.svg';
  import returnsIcon from '@/assets/images/illustrations/settings/commercial/returns.svg';
  import productsIcon from '@/assets/images/illustrations/settings/commercial/products.svg';
  import commissionsIcon from '@/assets/images/illustrations/settings/commercial/commissions.svg';
  import storesIcon from '@/assets/images/illustrations/settings/stores.svg';

  import SettingsList from '@/components/Settings/List.vue';

  export default {
    name: 'CommercialIndex',
    components: {
      SettingsList,
    },
    data() {
      return {
        items: [{
          title: 'Controle de retornos',
          description: 'Gerencie o seu R (retorno) nas vendas',
          icon: returnsIcon,
          url: { name: 'settings-commercial-returns' },
          permissions: ['admin', 'account_admin', 'account_manager', 'store_manager'],
        }, {
          title: 'Controle de preços',
          icon: pricesIcon,
          description: 'Gerencie os preços dos veículos',
          url: { name: 'settings-commercial-prices' },
          permissions: ['admin', 'account_admin', 'account_manager', 'store_manager'],
        }, {
          title: 'Controle de produtos',
          icon: productsIcon,
          description: 'Gerencie os seguros e outros produtos disponíveis',
          url: { name: 'settings-commercial-products' },
          permissions: ['admin', 'account_admin', 'account_manager', 'store_manager'],
        }, {
          title: 'Controle de comissões',
          icon: commissionsIcon,
          description: 'Gerencie as comissões a receber dos bancos',
          url: { name: 'settings-commercial-commissions-list' },
          permissions: ['admin', 'account_admin', 'account_manager', 'store_manager'],
        }, {
          title: 'Controle de bancos',
          icon: storesIcon,
          description: 'Gerencie a preferência por bancos ao exibir simulações publicamente',
          url: { name: 'settings-bank-ranking-list' },
          permissions: ['admin', 'account_admin', 'account_manager', 'store_manager'],
        }],
      };
    },
  };
</script>

<style lang="scss" scoped></style>
